/**
 * PPO controller interface.
 *
 * This is a placeholder only. It explicitly throws when invoked, making it
 * impossible to silently fly a non-functional "PPO" controller. A real trained
 * policy can be connected later by implementing the same Controller interface
 * without changing the simulator.
 */

import type { Environment, RocketState, ControlAction, Controller } from "../types";

export class PPOController implements Controller {
  readonly name = "ppo-interface";

  reset(): void {
    // No state to reset.
  }

  compute(_state: RocketState, _env: Environment, _dt: number): ControlAction {
    throw new Error(
      "PPOController: not implemented. A trained PPO policy has not been connected. " +
        "Use HandRuleController or PIDController instead."
    );
  }
}
